import { authFetch } from './fetch';
const baseUrl = '/api/Admin/Import';

export const createPeople = async (
  importName: string,
  file: File,
  teamId: string
): Promise<any> => {
  const formData = new FormData();
  formData.append('File', file);
  formData.append('ImportName', importName);
  formData.append('TeamId', teamId);

  try {
    const { data } = await authFetch.post(`${baseUrl}/People`, formData);
    return data;
  } catch (error: any) {
    return error.response.data;
  }
};

export const createProperties = async (
  importName: string,
  file: File
): Promise<any> => {
  const formData = new FormData();
  formData.append('File', file);
  formData.append('ImportName', importName);

  try {
    const { data } = await authFetch.post(`${baseUrl}/Properties`, formData);
    return data;
  } catch (error: any) {
    return error.response.data;
  }
};

export const createCompanies = async (
  importName: string,
  file: File
): Promise<any> => {
  const formData = new FormData();
  formData.append('File', file);
  formData.append('ImportName', importName);

  try {
    const { data } = await authFetch.post(`${baseUrl}/Companies`, formData);
    return data;
  } catch (error: any) {
    return error.response.data;
  }
};

export const createUnitMixes = async (
  importName: string,
  file: File
): Promise<any> => {
  const formData = new FormData();
  formData.append('File', file);
  formData.append('ImportName', importName);

  try {
    const { data } = await authFetch.post(`${baseUrl}/UnitMixes`, formData);
    return data;
  } catch (error: any) {
    return error.response.data;
  }
};

export const createInvestmentSales = async (
  importName: string,
  file: File
): Promise<any> => {
  const formData = new FormData();
  formData.append('File', file);
  formData.append('ImportName', importName);

  try {
    const { data } = await authFetch.post(`${baseUrl}/InvestmentSales`, formData);
    return data;
  } catch (error: any) {
    return error.response.data;
  }
};

export const createActiveInvestmentSales = async (
  importName: string,
  file: File
): Promise<any> => {
  const formData = new FormData();
  formData.append('File', file);
  formData.append('ImportName', importName);

  try {
    const { data } = await authFetch.post(
      `${baseUrl}/ActiveInvestmentSales`,
      formData
    );
    return data;
  } catch (error: any) {
    return error.response.data;
  }
};

/** Progress/summary of a background import, as returned by /Admin/Import/Jobs/{id}. */
export interface IImportJob {
  importJobId: number;
  importName: string;
  fileName: string;
  importMode: string;
  status:
    | 'Queued'
    | 'Processing'
    | 'Completed'
    | 'CompletedWithErrors'
    | 'Failed';
  totalRows: number;
  processedRows: number;
  createdCount: number;
  skippedCount: number;
  errorCount: number;
  failureMessage?: string;
  isFinished: boolean;
  hasErrorReport: boolean;
  percentComplete: number;
}

/**
 * Queues a Listing Stats import. The response comes back as soon as the file is parsed, so the
 * caller polls getImportJob for progress rather than waiting on this call.
 */
export const createListingStats = async (
  importName: string,
  file: File,
  importMode: 'Active' | 'Historical'
): Promise<{ job: IImportJob | null; errors: string[] | null }> => {
  const formData = new FormData();
  formData.append('File', file);
  formData.append('ImportName', importName);
  formData.append('ImportMode', importMode);

  try {
    const { data } = await authFetch.post(`${baseUrl}/ListingStats`, formData);
    return { job: data as IImportJob, errors: null };
  } catch (error: any) {
    const payload = error?.response?.data;
    const errors: string[] = payload?.errors?.length
      ? payload.errors
      : [payload?.title ?? 'Error importing document, please try again.'];
    return { job: null, errors };
  }
};

export const getImportJob = async (importJobId: number): Promise<IImportJob> => {
  const { data } = await authFetch.get(`${baseUrl}/Jobs/${importJobId}`);
  return data as IImportJob;
};

/** Pulls the row-level error report and hands it to the browser as a CSV download. */
export const downloadImportJobErrorReport = async (
  importJobId: number
): Promise<void> => {
  const { data } = await authFetch.getFile(
    `${baseUrl}/Jobs/${importJobId}/ErrorReport`,
    { responseType: 'blob' }
  );

  const url = window.URL.createObjectURL(new Blob([data], { type: 'text/csv' }));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', `import-${importJobId}-errors.csv`);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};

export const createFinancials = async (
  propertyId: number,
  file: File
): Promise<any> => {
  const formData = new FormData();
  formData.append('File', file);
  formData.append('PropertyId', propertyId.toString());

  try {
    const { data } = await authFetch.post(`${baseUrl}/Financials`, formData);
    return data;
  } catch (error: any) {
    return error.response.data;
  }
};